import React, { useState } from 'react';
import { DatePicker } from 'antd';

export default function YearPicker(props) {

  const { value, onChange, style } = props;
  const [isopen, setIsOpen] = useState(false);
  return (
    <DatePicker
      style={{...style}}
      allowClear={false}
      value={value}
      open={isopen}
      mode="year"
      placeholder="请选择年份"
      format="YYYY"
      onOpenChange={(status) => {
        if (status) {
          setIsOpen(true)
        } else {
          setIsOpen(false)
        }
      }}
      onPanelChange={(v) => {
        onChange(v);
        setIsOpen(false);
      }}
    />
  )
}
